<div class="navi">
    <ul>
      <li *ngIf="DataList.length < 1" class="m-b-6">
        <div class="text-center">{{'NoDataFound' | translate}}</div>
      </li>
        <li *ngFor="let data of DataList | slice:0:10" class="m-b-6" [ngClass]="{active:selected==data}">
            <a (click)="Show(data)">
                <ng-container *ngIf="columnName">
                  {{DisplayData(data,columnName)}}
                </ng-container>
                <ng-container *ngIf="columns.length > 0">
                  <ng-container *ngFor="let column of columns; let i = index">
                    <ng-container *ngIf="i > 0"> - </ng-container>
                    {{DisplayData(data,column)}}
                  </ng-container>
                </ng-container>
            </a>
        </li>
        <ng-container *ngIf="isExpanded">
            <ng-container *ngFor="let data of DataList; let i = index">
                <li *ngIf="i >= 10" class="m-b-6" [ngClass]="{active:selected==data}">
                    <a (click)="Show(data)">
                      <ng-container *ngIf="columnName">
                        {{DisplayData(data,columnName)}}
                      </ng-container>
                      <ng-container *ngIf="columns.length > 0">
                        <ng-container *ngFor="let column of columns; let j = index">
                          <ng-container *ngIf="j > 0"> - </ng-container>
                          {{DisplayData(data,column)}}
                        </ng-container>
                      </ng-container>
                    </a>
                </li>
            </ng-container>
        </ng-container>

        <li *ngIf="DataList.length > 10 && !isExpanded">
            <button mat-button (click)="expandItems()" class="btnShowAll">
                {{'ShowAll'|translate}}
            </button>
        </li>
    </ul>

    <!-- <ul *ngIf="DataList.length <= 10">
        <li *ngFor="let data of DataList" class="m-b-6" [ngClass]="{active:selected==data[columnName]}">
            <a (click)="Show(data)">
                {{data[columnName]}}
            </a>
        </li>
    </ul> -->
</div>
